// extracted by mini-css-extract-plugin
export default {"card":"OverviewCard_card__ukKwr","icon":"OverviewCard_icon__q4W3M","title":"OverviewCard_title__+T+8U"};